import React from "react";

export default function SimpleInput({
  id,
  error,
  placeholder,
  borderColor,
  className,
  props,
  Leading,
  Trailing,
  field_name,
  onChange,
  onBlur,
  inputType,
  setActiveElement,
}) {
  const idRef = React.useRef(id || randomId());

  return (
    <div className={`relative font-normal items-center ${className}`}>
      <input
        id={idRef.current}
        name={field_name}
        placeholder={placeholder}
        autoComplete="off"
        onFocus={() => setActiveElement(field_name)}
        type={inputType || "text"}
        {...props}
        className={`peer border h-12 w-full disabled:opacity-60 ${
          error ? "!text-red-600" : "!text-gray-800"
        } ${Leading ? "pl-10" : "pl-6"} pr-2 py-2 bg-white text-md
          font-normal rounded-lg outline-none ${
            error ? "ring-err-base" : ""
          } input-invalid`}
        style={{ borderColor: error ? "#dc2626" : borderColor }}
        onChange={(e) => {
          onChange(field_name, e.target.value);
        }}
        onBlur={(e) => {
          onBlur(field_name, e.target.value);
        }}
      />
      {Leading && (
        <div
          className={`absolute left-2.5 top-1/2 -translate-y-1/2 label-invalid text-gray-800`}
        >
          {Leading}
        </div>
      )}
      {Trailing && (
        <div
          className={`absolute right-6 top-1/2 -translate-y-1/2 text-gray-800 label-invalid`}
        >
          {Trailing}
        </div>
      )}
      {error && (
        <div className="text-red-600 ml-4 text-xs px-2 -bottom-1 bg-white rounded absolute">
          {error}
        </div>
      )}
    </div>
  );
}

const randomId = () => {
  const rnd = Math.round(Math.random() * 100000).toString();
  return `id-${rnd}`;
};
